// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"base-filter_wrapper__VlMsx","selected":"base-filter_selected__s9zSp","chevronContainer":"base-filter_chevronContainer__vkqNi","rotated":"base-filter_rotated__n9ph5"};